module.exports = __webpack_public_path__ + "media/src/images/apple-icon-72x72-9d3a9d774d952676a51a5b0bedc7950b.png";